import { DialogueLogicKey } from '@kp/dialogue/models/dialogue.model';
import { Deserializable, JsonObject } from '@ktypes/models';

export enum DialogueStatus {
  not_started = 'not_started',
  started = 'started',
  completed = 'completed',
}

export interface DailyReflectionDialogueData {
  todayMessage: string;
  buttonText: string;
}

export interface OnboardingDialogueData {
  explanation: string;
}

export type DialogueStatusData = DailyReflectionDialogueData | OnboardingDialogueData;

export class DialogueDataStatus implements Deserializable<JsonObject, DialogueDataStatus> {
  constructor(
    public dialogueId?: string,
    public dialogueStatus?: DialogueStatus,
    public logicKey?: DialogueLogicKey,
    public data?: DialogueStatusData
  ) {}

  deserialize(input: JsonObject): DialogueDataStatus {
    this.dialogueId = input['userDialogueId'];
    this.dialogueStatus = input['status'] as DialogueStatus;
    this.logicKey = input['logicKey'] as DialogueLogicKey;
    this.data = input['data'] as DialogueStatusData;
    return this;
  }
}
